import { render } from "./ContactPageInfo.vue?vue&type=template&id=6b223da4&scoped=true"
const script = {}

import "./ContactPageInfo.vue?vue&type=style&index=0&id=6b223da4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b223da4"]])

export default __exports__